class ModulesFactory {
    constructor(definitions = {}) {
        this.definitions = definitions;
        for (const module in this.definitions) {
            const nodes = document.querySelectorAll(`[data-module="${module}"]`)
            nodes.forEach((n) => n.moduleInstance = new this.definitions[module](n))
        }
    }

    static getModuleInstance(node){
        return node && node.moduleInstance ? node.moduleInstance : null;
    }
}


export default ModulesFactory;